<template>
  <td class="text-right">
    <div class="btn-group">
      <router-link :to="{ name: editName, params: { id: entry._id } }" class="btn btn-muted" :title="$t('general.edit')">
        <font-awesome-icon icon="edit" />
      </router-link>
      <button class="btn btn-muted" @click="pdf(entry._id)" :title="$t('general.pdf')">
        <font-awesome-icon icon="file-pdf" />
      </button>
      <button class="btn btn-muted" @click="mail(entry._id)" :title="$t('general.mail')">
        <font-awesome-icon icon="envelope" />
      </button>
      <button class="btn btn-muted" @click="trash(entry._id)" :title="$t('general.delete')">
        <font-awesome-icon icon="trash" />
      </button>
    </div>
  </td>
</template>

<script>
export default {
  props: ['entity', 'entry', 'editName'],
};
</script>
